module.exports = __webpack_public_path__ + "static/media/Inkay_gaussian2.41573a7e.png";